import React from 'react';

interface Props {
  width: number;
  height: number;
}

const SvgFaq = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 78C64.5685 78 78 64.5685 78 48C78 31.4315 64.5685 18 48 18C31.4315 18 18 31.4315 18 48C18 64.5685 31.4315 78 48 78Z"
      fill="#82DCE1"
    />
    <path
      d="M77 48C77 64.0163 64.0163 77 48 77C31.9837 77 19 64.0163 19 48C19 31.9837 31.9837 19 48 19C64.0163 19 77 31.9837 77 48Z"
      stroke="url(#paint0_linear_51736_10023)"
      strokeOpacity="0.1"
      strokeWidth="2"
    />
    <g filter="">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.1401 40.2998C38.1401 34.7498 43.2601 30.5098 49.0901 31.0998C53.5901 31.5598 57.2801 34.9498 57.7901 39.2398C58.1501 42.2198 57.0101 44.6398 54.6501 47.0298L54.1301 47.5398C52.2401 49.3198 50.7701 51.6698 50.5401 53.4598L50.5101 53.9298V54.5898C50.5101 55.9698 49.3901 57.0898 48.0101 57.0898C46.7401 57.0898 45.7001 56.1498 45.5301 54.9298L45.5101 54.5898V53.9298C45.5101 50.6598 47.4501 47.1898 50.1201 44.4698L50.7001 43.8998C52.3801 42.3198 52.9901 41.1498 52.8301 39.8298C52.6001 37.9398 50.8201 36.2998 48.5901 36.0698C45.7801 35.7898 43.4201 37.5898 43.1701 39.8898L43.1501 40.2998C43.1501 41.6798 42.0301 42.7998 40.6501 42.7998C39.2701 42.7998 38.1501 41.6798 38.1501 40.2998H38.1401ZM48.0001 58.8698C46.1901 58.8698 44.7101 60.3398 44.7101 62.1598C44.7101 63.9798 46.1801 65.4498 48.0001 65.4498C49.8201 65.4498 51.2901 63.9798 51.2901 62.1598C51.2901 60.3398 49.8201 58.8698 48.0001 58.8698Z"
        fill="url(#paint1_linear_51736_10023)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M57.2936 39.2988L57.2937 39.2998C57.6298 42.0812 56.5856 44.3571 54.2971 46.6757L53.7836 47.1793C52.809 48.0978 51.9419 49.1633 51.2861 50.2351C50.6331 51.3024 50.1715 52.4058 50.0442 53.3961L50.0422 53.412L50.0412 53.4279L50.0112 53.898L50.0101 53.9139V53.9298V54.5898C50.0101 55.6937 49.114 56.5898 48.0101 56.5898C47.0012 56.5898 46.1722 55.8484 46.028 54.8794L46.0101 54.5751V53.9298C46.0101 50.8444 47.8525 47.4948 50.4738 44.8232L51.0467 44.2603C52.7573 42.6505 53.5159 41.3323 53.3265 39.7696L53.3265 39.7694C53.0638 37.6107 51.0643 35.8223 48.6414 35.5724L48.6397 35.5723C45.6104 35.2704 42.9582 37.2122 42.6731 39.8358L42.6715 39.8506L42.6707 39.8654L42.6507 40.2754L42.6501 40.2876V40.2998C42.6501 41.4037 41.754 42.2998 40.6501 42.2998C39.5463 42.2998 38.6501 41.4037 38.6501 40.2998V39.8895C38.8953 34.873 43.6126 31.0481 49.0396 31.5972C53.3305 32.036 56.814 35.2644 57.2936 39.2988ZM45.2101 62.1598C45.2101 60.6169 46.4653 59.3698 48.0001 59.3698C49.544 59.3698 50.7901 60.6159 50.7901 62.1598C50.7901 63.7037 49.544 64.9498 48.0001 64.9498C46.4563 64.9498 45.2101 63.7037 45.2101 62.1598Z"
        stroke="url(#paint2_linear_51736_10023)"
        strokeOpacity="0.1"
        strokeLinecap="round"
        shapeRendering="geometricPrecision"
      />
    </g>
    <path
      d="M70 86C78.8366 86 86 78.8366 86 70C86 61.1634 78.8366 54 70 54C61.1634 54 54 61.1634 54 70C54 78.8366 61.1634 86 70 86Z"
      fill="#29BBCF"
    />
    <path
      d="M85 70C85 78.2843 78.2843 85 70 85C61.7157 85 55 78.2843 55 70C55 61.7157 61.7157 55 70 55C78.2843 55 85 61.7157 85 70Z"
      stroke="url(#paint3_linear_51736_10023)"
      strokeOpacity="0.1"
      strokeWidth="2"
    />
    <g filter="">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.9998 60.8399C72.8598 59.9899 72.1298 59.3599 71.2698 59.3599H68.5898C67.7298 59.4399 67.0298 60.1399 66.9898 61.0199L66.9298 61.7799L66.9098 61.9499L66.8698 62.1199C66.7698 62.4999 66.5398 62.8199 66.2198 63.0499L66.0798 63.1399L66.0498 63.1599L65.8998 63.2399C65.4498 63.4399 64.9198 63.4399 64.4498 63.2099L63.7498 62.8499L63.5998 62.7799C62.8098 62.4699 61.8998 62.7899 61.4498 63.5199L60.1698 65.7499L60.0998 65.8999C59.7498 66.6899 59.9898 67.5999 60.6898 68.0899L61.3398 68.5299L61.4798 68.6399C61.8698 68.9699 62.0998 69.4599 62.0998 69.9699C62.0998 70.5499 61.8098 71.0899 61.3498 71.3999L60.6998 71.8399L60.5698 71.9399C59.8998 72.4899 59.7198 73.4599 60.1898 74.2099L61.4398 76.4099L61.5198 76.5499C61.9998 77.2599 62.9298 77.5099 63.7298 77.1199L64.4598 76.7599L64.6098 76.6999L64.7698 76.6499C65.1398 76.5599 65.5398 76.5899 65.9098 76.7499L65.9798 76.7799L66.0698 76.8299L66.2098 76.9199C66.6298 77.2199 66.8898 77.6799 66.9298 78.1899L66.9898 78.9799L67.0098 79.1299C67.1498 79.9799 67.8798 80.6099 68.7398 80.6099H71.4198C72.2798 80.5299 72.9798 79.8299 73.0198 78.9499L73.0798 78.1899L73.0998 78.0199L73.1398 77.8499C73.2398 77.4699 73.4698 77.1499 73.7898 76.9199L73.9298 76.8199L73.9598 76.7999L74.1098 76.7199C74.5598 76.5199 75.0898 76.5199 75.5598 76.7499L76.2798 77.0999L76.4198 77.1599C77.1998 77.4599 78.1098 77.1399 78.5598 76.4099L79.8398 74.1799L79.9098 74.0399C80.2598 73.2799 80.0198 72.3699 79.3398 71.8599L78.6698 71.3999L78.5298 71.2899C78.1398 70.9599 77.9098 70.4699 77.9098 69.9599C77.9098 69.3799 78.1998 68.8399 78.6598 68.5299L79.3098 68.0899L79.4398 67.9899C80.1098 67.4399 80.2898 66.4699 79.8198 65.7199L78.5698 63.5399L78.4898 63.3999C78.0198 62.6999 77.0798 62.4499 76.2798 62.8299L75.5498 63.1899L75.3998 63.2499L75.2398 63.2999C74.8698 63.3899 74.4698 63.3599 74.0998 63.1999L74.0298 63.1699L73.9398 63.1199L73.7998 63.0299C73.3798 62.7299 73.1198 62.2699 73.0798 61.7599L73.0198 60.9699L72.9998 60.8199V60.8399ZM70.0098 65.3799C72.5498 65.3799 74.5998 67.4599 74.5998 69.9999C74.5998 72.5399 72.5498 74.6199 70.0098 74.6199C67.4698 74.6199 65.4198 72.5399 65.4198 69.9999C65.4198 67.4599 67.4698 65.3799 70.0098 65.3799ZM67.9898 69.9999C67.9898 68.8699 68.8998 67.9499 70.0098 67.9499C71.1198 67.9499 72.0298 68.8699 72.0298 69.9999C72.0298 71.1299 71.1198 72.0499 70.0098 72.0499C68.8998 72.0499 67.9898 71.1299 67.9898 69.9999Z"
        fill="url(#paint4_linear_51736_10023)"
        shapeRendering="geometricPrecision"
      />
      <path
        d="M72.5064 60.9211L72.5088 60.9209L72.5223 61.0219L72.5812 61.7977L72.5813 61.799C72.6329 62.457 72.9695 63.0513 73.5091 63.4367L73.5191 63.4438L73.5294 63.4504L73.6694 63.5405L73.6829 63.5491L73.6969 63.5569L73.7869 63.6069L73.8093 63.6194L73.8328 63.6294L73.9013 63.6588C73.9016 63.6589 73.9018 63.659 73.9021 63.6591C74.372 63.8621 74.8829 63.9012 75.3579 63.7857L75.3736 63.7819L75.3889 63.7771L75.5489 63.7271L75.5674 63.7213L75.5855 63.7141L75.7355 63.6541L75.7535 63.6469L75.7709 63.6383L76.4974 63.28C77.0781 63.006 77.7373 63.1912 78.0654 63.665L78.1356 63.7879L78.136 63.7886L79.386 65.9686L79.3909 65.9771L79.3961 65.9854C79.7268 66.5132 79.6055 67.2023 79.1281 67.5988L79.0169 67.6843L78.3803 68.1152C78.3801 68.1154 78.3799 68.1155 78.3797 68.1157C77.7802 68.52 77.4098 69.2162 77.4098 69.9599C77.4098 70.6189 77.706 71.2478 78.2068 71.6716L78.2137 71.6774L78.2208 71.683L78.3608 71.793L78.3735 71.803L78.3868 71.8121L79.0475 72.2657C79.5368 72.6382 79.7014 73.2887 79.4587 73.824L79.399 73.9434L78.1303 76.1536C77.8016 76.6805 77.1495 76.9002 76.6073 76.6962L76.4877 76.645L75.7795 76.3008C75.7793 76.3006 75.7791 76.3005 75.7788 76.3004C75.174 76.0047 74.4894 76.004 73.9067 76.263L73.8903 76.2702L73.8745 76.2787L73.7245 76.3587L73.7028 76.3702L73.6824 76.3838L73.6524 76.4038L73.6457 76.4083L73.6391 76.413L73.4991 76.513L73.4979 76.5139C73.09 76.8071 72.7877 77.2229 72.6562 77.7226L72.6561 77.7226L72.6531 77.7353L72.613 77.9053L72.6065 77.9331L72.6032 77.9614L72.5832 78.1314L72.5821 78.141L72.5813 78.1505L72.5213 78.9105L72.5207 78.9188L72.5203 78.9272C72.4924 79.5413 72.0058 80.0427 71.3946 80.1099H68.7398C68.1314 80.1099 67.608 79.665 67.5043 79.0556L67.4872 78.9278L67.4283 78.152L67.4282 78.1508C67.3766 77.4928 67.04 76.8984 66.5004 76.513L66.4904 76.5059L66.4801 76.4993L66.3401 76.4093L66.3266 76.4006L66.3126 76.3928L66.2226 76.3428L66.2002 76.3304L66.1767 76.3203L66.1082 76.2909C66.1079 76.2908 66.1076 76.2907 66.1074 76.2906C65.6374 76.0876 65.1266 76.0485 64.6516 76.164L64.636 76.1678L64.6206 76.1726L64.4606 76.2226L64.4421 76.2284L64.4241 76.2356L64.2741 76.2956L64.256 76.3028L64.2386 76.3114L63.5107 76.6704C63.5103 76.6706 63.51 76.6707 63.5097 76.6709C62.9346 76.9507 62.284 76.7724 61.9437 76.284L61.8745 76.1629L61.8739 76.1618L60.6245 73.9629L60.6192 73.9535L60.6134 73.9444C60.2827 73.4166 60.404 72.7274 60.8814 72.331L60.9926 72.2454L61.6292 71.8145C61.6294 71.8144 61.6296 71.8142 61.6298 71.8141C62.2293 71.4098 62.5998 70.7135 62.5998 69.9699C62.5998 69.3108 62.3035 68.6819 61.8027 68.2582L61.7958 68.2523L61.7887 68.2467L61.6487 68.1367L61.6347 68.1257L61.62 68.1158L60.9736 67.6782C60.4798 67.3305 60.3016 66.6837 60.5551 66.1065L60.6139 65.9804L61.8792 63.7761C62.206 63.2523 62.853 63.0316 63.4038 63.2402L63.5296 63.2989L64.2211 63.6545L64.221 63.6546L64.23 63.659C64.835 63.955 65.5199 63.9559 66.1028 63.6968L66.1192 63.6895L66.1351 63.681L66.2851 63.601L66.3067 63.5895L66.3271 63.5759L66.3536 63.5582L66.4901 63.4705L66.501 63.4634L66.5116 63.4559C66.9195 63.1626 67.2218 62.7469 67.3533 62.2471L67.3535 62.2472L67.3565 62.2344L67.3965 62.0644L67.403 62.0366L67.4063 62.0083L67.4263 61.8383L67.4275 61.8288L67.4282 61.8192L67.4882 61.0592L67.4889 61.0509L67.4892 61.0426C67.5172 60.4284 68.0037 59.927 68.6149 59.8599H71.2698C71.8805 59.8599 72.4054 60.3082 72.5064 60.9211ZM75.0998 69.9999C75.0998 67.188 72.8301 64.8799 70.0098 64.8799C67.1894 64.8799 64.9198 67.188 64.9198 69.9999C64.9198 72.8118 67.1894 75.1199 70.0098 75.1199C72.8301 75.1199 75.0998 72.8118 75.0998 69.9999ZM68.4898 69.9999C68.4898 69.1396 69.1823 68.4499 70.0098 68.4499C70.8372 68.4499 71.5298 69.1396 71.5298 69.9999C71.5298 70.8601 70.8372 71.5499 70.0098 71.5499C69.1823 71.5499 68.4898 70.8601 68.4898 69.9999Z"
        stroke="url(#paint5_linear_51736_10023)"
        strokeOpacity="0.1"
        strokeLinecap="round"
        shapeRendering="geometricPrecision"
      />
    </g>
    <defs>
      <filter
        id="filter0_di_51736_10023"
        x="38.1401"
        y="31.0449"
        width="19.7153"
        height="35.4048"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_10023"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_10023"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_10023"
        />
      </filter>
      <filter
        id="filter1_di_51736_10023"
        x="59.9268"
        y="59.3599"
        width="20.1558"
        height="22.25"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51736_10023"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51736_10023"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51736_10023"
        />
      </filter>
      <linearGradient
        id="paint0_linear_51736_10023"
        x1="48"
        y1="18"
        x2="48"
        y2="78"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_51736_10023"
        x1="47.9978"
        y1="31.0449"
        x2="47.9978"
        y2="65.4498"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_51736_10023"
        x1="47.9978"
        y1="31.0449"
        x2="47.9978"
        y2="65.4498"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_51736_10023"
        x1="70"
        y1="54"
        x2="70"
        y2="86"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_51736_10023"
        x1="70.0048"
        y1="59.3599"
        x2="70.0048"
        y2="80.6099"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_51736_10023"
        x1="70.0048"
        y1="59.3599"
        x2="70.0048"
        y2="80.6099"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgFaq;
